export default __webpack_public_path__ + "static/media/kho-kho.83f21e37.png";